import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getModelConfigs } from '../services/apiEndpoints';


export const fetchModelConfigs = createAsyncThunk(
    'user/fetchModelConfigs',
    async (_, thunkAPI) => {
      try {
        const response = await getModelConfigs();
        return response;
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        return thunkAPI.rejectWithValue(errorMessage);
      }
    }
  );

interface IModelConfigsState {
    modelConfigs: Array<Record<string, unknown>>;
    error: any;
}

const initialState: IModelConfigsState = {
    modelConfigs: [],
    error: null
  };

  const modelSlice = createSlice({
    name: 'model',
    initialState,
    reducers: {
      addModelConfigs(state, action){
        state.modelConfigs = action.payload;
      }
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchModelConfigs.fulfilled, (state, action) => {
          state.modelConfigs = action.payload.data;
        })
        .addCase(fetchModelConfigs.rejected, (state, action) => {
          state.error = action.payload as string ?? null;
        });
    },
  });
  
export const { addModelConfigs } = modelSlice.actions 
export default modelSlice.reducer;